
<template>
   <v-container fluid>
      <v-layout row wrap>
         <v-flex xs12>
            <div v-html="compiledMarkdown" class="craps_doc_markdown"></div>
         </v-flex>
      </v-layout>
   </v-container>
</template>


<script>
   import marked from 'marked'
   import crapsDocText from './craps-doc.txt'

   export default {
      computed: {
         compiledMarkdown: function () {
            return marked(crapsDocText, { sanitize: true })
         }
      },
   }
</script>

<style lang="scss" scoped>
   /* customization of pre & code: see App.vue style section */
   .craps_doc_markdown {
      font-size: 1.2em;
      font-weight: normal;
      margin: 20px;
   }
</style>



// WEBPACK FOOTER //
// CrapsDoc.vue?dfbd04d2